import { abbreviation } from '@/config/helpers.js'
export default (value, { isCurrency, isInteger } = {}) => {
  if (isNaN(value)) return '-'
  return abbreviation(value, { isCurrency, isInteger })
}
